import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/buttons/button';
import i18n from 'i18next';
import { showModal } from 'src/modules/shared/modal/actions';
import Modal from 'src/modules/shared/modal/components/modal';
import { connect } from 'react-redux';
import { resendVerificationLink } from 'src/modules/shared/context/actions';
import { truncate } from 'underscore.string';

class VerificationBar extends Component {

  onResendEmailClick = () => {
    const { showModal, resendVerificationLink } = this.props;
    resendVerificationLink();
    showModal(null);
  }

  onInformationClick = () => {
    const { unverifiedEmail, showModal } = this.props;
    showModal(<Modal title={i18n.t('Email confirmation')}>
      <div className="verification-bar__information-modal">
        <p>{i18n.t('Having a valid email address helps us know that you’re human and well meaning.')}</p>
        <p>{i18n.t('You won’t be able to make use of all features on HealthUnlocked until you confirm your email address.')}</p>
        <p>{i18n.t('To confirm your email address simply click the link in the email we sent to %1$s.').replace('%1$s', unverifiedEmail)}</p>
        <p>{i18n.t('You can have the email resent or you can update your email address below.')}</p>
        <div>
          <button className="btn btn-primary" onClick={this.onResendEmailClick}>{i18n.t('Resend Email')}</button>
          <a href="/settings">{i18n.t('Update email')}</a>
        </div>
      </div>
    </Modal>);
  }

  render() {
    const { unverifiedEmail } = this.props;
    return (
      <div className="verification-bar">
        <div className="verification-bar__inner">
          <div className="verification-bar__copy">
            {i18n.t('To make use of all our features click the link in the email sent to %1$s').replace('%1$s', unverifiedEmail)}
            <span className="icon-information" onClick={this.onInformationClick}></span>
          </div>
          <div className="verification-bar__actions">
            <Button
              backgroundColor="#333"
              border="1px solid white"
              onClick={this.onResendEmailClick}
              text="Resend"
            />
            <a href="/settings">
              <Button
                backgroundColor="#333"
                border="none"
                text="Update email"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    unverifiedEmail: truncate(state.context.currentUser.unverifiedEmail, 20),
  };
};

VerificationBar.propTypes = {
  unverifiedEmail: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, { showModal, resendVerificationLink })(VerificationBar);



// WEBPACK FOOTER //
// ./src/components/verificationBar.js